import { Component, OnInit, Input, ElementRef, ViewChild, Output, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Events } from '@ionic/angular';
import { UserService } from 'src/app/services/user/user.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { EventEmitter } from '@angular/core';
import { HeaderUtilsService } from '../header-utils.service';


@Component({
    selector: 'app-header-six',
    templateUrl: './header-six.component.html',
    styleUrls: ['./header-six.component.scss'],
})
export class HeaderSixComponent implements OnInit {
    @Input() headerData: any;
    @Input() data: any;
    @Input() region: any;
    @Output() openRegionModalEvent = new EventEmitter();
    @Input() stickyHeader: boolean;
    @Output() getStickyHeight = new EventEmitter();

    @ViewChild('navMenu', {
        static: false
    }) navMenu: ElementRef;


    loginStatus = false;
    isPriceReq: boolean;
    showPrices: boolean;
    page: number = 0;
    stickyHeight = 150;
    isIOS;
    role: any;
    userId: string = '';
    priceForRetail = false;
    currencyCode: any;
    RFQFeature = false;
    constructor(private router: Router,
        private events: Events,
        public userService: UserService,
        private headerUtilsService: HeaderUtilsService,
        private utilsService: UtilsService, ) { }

    dropMenu() {
        const navMenu = this.navMenu.nativeElement.parentNode.classList;
        console.log(navMenu.toggle('dBlock'));
    }

    openRegionModal(type) {
        this.openRegionModalEvent.emit(type);
    }

    async ngOnInit() {
        console.log('header 6', this.headerData)
        if (this.data) {
            this.role = this.data.role;
            this.priceForRetail = this.data.priceForRetail;
            this.currencyCode = this.data.currencyCode;
            this.RFQFeature = this.data.loginStatus;
        }
        this.initializeSubscriptions();

        this.loginStatus = this.headerUtilsService.getLoginStatus();


    }
    async initializeSubscriptions() {
        this.events.subscribe('auth:logoutSuccess', () => {
            this.loginStatus = false;
        })
    }

    ngOnDestroy() {
        this.removeSubscriptions();
    }
    removeSubscriptions() {
        this.events.subscribe('auth:logoutSuccess');
    }
    logout() {
        this.events.publish('auth:logout');
    }
    async openLoginModal() {
        this.utilsService.openLoginModal();
    }
    openSearchPage() {
        this.headerUtilsService.openSearchPage();
    }
}
